import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cx from 'classnames';
import DropList from './conditionSetupComponents/DropList';
import LoadingBtn from './conditionSetupComponents/loading-button';
import NewTabIcon from './conditionSetupComponents/NewTabIcon.jsx';
import ValidInput from './conditionSetupComponents/ValidInput.jsx';
import MultiInput from 'ui/components/multi-input';
import TemperatureConverterToggle from './conditionSetupComponents/TemperatureConverterToggle.jsx';
import i18n from 'i18next';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux'; // import {
//     selectProductVersion,
//     selectLng
// } from 'selectors/envConfig'

import { getConfig, convertToCelsius, convertToFahrenheit, validateNumber } from './conditionSetupComponents/utils';
import { createGeoCondObj, getConditionJson } from '../../utils/conditionParser'; // import * as fromConditionParser from 'utils/conditionParser'
// import * as fph from 'utils/permissionHelper'
// import { getIsShowConditionParameterId } from 'utils/queryHelper'
// import { downloadFile, convertToCelsius, convertToFahrenheit, validateNumber } from '../../utils'

import DrawingToolView, { drawingToolApp } from '../ui/DrawingToolApp';
import DynamicRadio from './conditionSetupComponents/DynamicRadio';
import TimelineIcon from '@material-ui/icons/Timeline';
var t = i18n.getFixedT(null, 'setting-device'); // const gt = i18n.getFixedT(null, 'app')
// const iva = i18n.getFixedT(null, 'iva')
// const _cond = i18n.getFixedT(null, 'condition')

var er = i18n.getFixedT(null, 'errors'); // const tc = i18n.getFixedT(null, 'channels')

var graphicIconMap = {
  roi: "icon-ic_path_ROI",
  line: "icon-ic_path_line",
  polyline: "icon-ic_path_polyline",
  rectangle: "icon-ic_path_region",
  polygon: 'icon-ic_path_rectangle_2',
  direction: "icon-ic_path_arrow",
  geoGroup: "icon-ic_folder_2",
  polyline_pair: "icon-ic_draw_polylinepair"
};
var graphicPrefix = {
  area: "area",
  area_: "area_",
  direction: "direction",
  direction_: "direction_",
  cross_line_: "cross_line_",
  cross_line: "cross_line",
  line: "line",
  line_: "line_",
  cross_line_pair: "cross_line_pair",
  cross_line_pair_: "cross_line_pair_",
  bir_analysis_roi: "bir_analysis_roi",
  bir_crossing_line: "bir_crossing_line",
  bir_trace_line: "bir_trace_line",
  bir_dwelling_roi: "bir_dwelling_roi",
  bir_occupancy_roi: "bir_occupancy_roi",
  calibration_area: "calibration_area"
};
var Parameter = {
  "BOOLEAN": "boolean",
  "FLOAT": "float",
  "INTEGER": "integer",
  "RADIO": "radio",
  "DYNAMIC_RADIO": "dynamic_radio",
  "MULTI_SELECTION": "multi_selection",
  "MULTI_STRING": "multi_string",
  "STRING": "string"
};

var ConditionSetupPopup = /*#__PURE__*/function (_Component) {
  _inherits(ConditionSetupPopup, _Component);

  var _super = _createSuper(ConditionSetupPopup);

  function ConditionSetupPopup() {
    var _this;

    _classCallCheck(this, ConditionSetupPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      width: 640,
      height: 480,
      drawingMode: "dragging",
      //"line",
      isErase: false,
      isDrawing: false,
      isApplyLoading: false,
      isShowAdvancedSettings: false,
      isInvalid: {},
      showPermissionDenyTip: {
        condPanel: false,
        mouse: false,
        eraser: false,
        trashcan: false,
        graphic: false,
        edit: false
      },
      conditionJson: null,
      currentGeoItem: null,
      imgUrl: _this.props.imgUrl,
      graphSizeReady: false,
      isDisplayInFahrenheitList: {}
    });

    _defineProperty(_assertThisInitialized(_this), "multiStrParams", {});

    _defineProperty(_assertThisInitialized(_this), "isInitialing", false);

    _defineProperty(_assertThisInitialized(_this), "init", function () {
      if (_this.isInitialing) {
        return;
      }

      _this.isInitialing = true;

      var cond = _this.getCurrentConditionItem();

      var _this$props$selectedC = _this.props.selectedCondition,
          cid = _this$props$selectedC.cid,
          sid = _this$props$selectedC.sid;
      var conditionJson = getConditionJson(cid, sid, cond);
      console.log('hl condition json: ', conditionJson);
      var root = conditionJson.geoItems.find(function (item) {
        return item.gid == "condition_root";
      });

      _this.setState({
        conditionJson: conditionJson,
        currentGeoItem: root
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drawingToolAutoResize", function () {
      // return
      var width = _.get(document.getElementById('DrawingToolAppBox'), 'offsetWidth', 640);

      var height = _.get(document.getElementById('DrawingToolAppBox'), 'offsetHeight', 480);

      if (width > 1280) {
        height = height * (1280 / width);
        width = 1280;
      }

      _this.setState({
        width: width,
        height: height,
        graphSizeReady: true
      });

      _this.startCanvasResize();
    });

    _defineProperty(_assertThisInitialized(_this), "startCanvasResize", function () {
      window.addEventListener('resize', _this.resizeThrottler, false);
    });

    _defineProperty(_assertThisInitialized(_this), "resizeThrottler", function () {
      if (_this.resizeTimeout) {
        return;
      } // ignore resize events as long as an actualResizeHandler execution is in the queue


      var actualResizeHandler = function actualResizeHandler() {
        var width = _.get(document.getElementById('DrawingToolAppBox'), 'offsetWidth', 640);

        var height = _.get(document.getElementById('DrawingToolAppBox'), 'offsetHeight', 480);

        _this.setState({
          width: width,
          height: height
        });
      };

      _this.resizeTimeout = setTimeout(function () {
        _this.resizeTimeout = null;
        actualResizeHandler(); // The actualResizeHandler will execute at a rate of 15fps
      }, 10);
    });

    _defineProperty(_assertThisInitialized(_this), "stopCanvasResize", function () {
      window.removeEventListener("resize", _this.resizeThrottler);
      clearTimeout(_this.resizeTimeout);
    });

    _defineProperty(_assertThisInitialized(_this), "sortCondItem", function (a, b) {
      // if(a.$.visibility == 'optional') {
      //     if(b.$.visibility !='optional') {
      //         return 1 // b go first
      //     }
      // } else {
      //     if(b.$.visibility =='optional') {
      //         return -1 // a go first
      //     }
      // }
      // const aOrder = a.$.order || Infinity
      // const bOrder = b.$.order || Infinity
      var aOrder = a.attr.order || Infinity;
      var bOrder = b.attr.order || Infinity;
      return aOrder - bOrder;
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentConditionItem", function () {
      var selectedCondition = _this.props.selectedCondition;
      var cid = selectedCondition.cid,
          sid = selectedCondition.sid;

      if (window.isDev) {
        window.selectedCondition = selectedCondition;

        window.downloadJson = function () {
          var cj = _this.state.conditionJson; // downloadFile({ content: JSON.stringify(cj, null, 2), fileName: "condition.json" })
        };
      }

      return selectedCondition.getCondition(cid, sid);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentParameterList", function (conditionItem) {
      var c = conditionItem || _this.getCurrentConditionItem();

      return Object.keys(c.parameterList).map(function (k) {
        return c.parameterList[k];
      }).sort(_this.sortCondItem);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentConditionItemName", function () {
      try {
        var selectedCondition = _this.props.selectedCondition;
        var cid = selectedCondition.cid,
            sid = selectedCondition.sid;

        var cond = _this.getCurrentConditionItem();

        if (sid) {
          return t("subcondition_list." + cond.$.name);
        }

        return t("condition." + cond.$.name);
      } catch (error) {
        console.warn('getCurrentConditionItemName fail', error);
        return "";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleParameter", function (_ref, value) {
      var pid = _ref.pid,
          type = _ref.type,
          xmlObj = _ref.xmlObj;
      var currentGeoItem = _this.state.currentGeoItem;
      var selectedCondition = _this.props.selectedCondition;
      var cid = selectedCondition.cid,
          sid = selectedCondition.sid;
      var geoCondObj = undefined;

      try {
        if (currentGeoItem.isGeoCondition) {
          var gcid = currentGeoItem.gid;

          if (xmlObj.length > 0) {
            var layer1 = xmlObj.find(function (it) {
              return it.layer == 1;
            });

            if (layer1 && layer1.geoCondId) {
              gcid = layer1.geoCondId;
            }
          }

          geoCondObj = createGeoCondObj({
            gcid: gcid,
            paramType: type,
            xmlObjList: xmlObj
          });
        }
      } catch (e) {
        console.error('updateParameter fail', e);
      } // this.props.onChangeParameter(cid, sid, geoCondObj, pid, value)


      _this.props.onChangeParameter({
        cid: cid,
        sid: sid,
        pid: pid,
        geoCondObj: geoCondObj
      }, value);

      _this.refreshConditionJson();
    });

    _defineProperty(_assertThisInitialized(_this), "getGcid", function () {
      var currentGeoItem = _this.state.currentGeoItem;
      var gcid = undefined;
      if (currentGeoItem.isGeoCondition) gcid = currentGeoItem.gid; // 支援多圖 geo-condition

      if (currentGeoItem.parent) gcid = currentGeoItem.parent;
      return gcid;
    });

    _defineProperty(_assertThisInitialized(_this), "setGeometry", function (gid, oindex, value) {
      var selectedCondition = _this.props.selectedCondition;
      var cid = selectedCondition.cid,
          sid = selectedCondition.sid;

      var gcid = _this.getGcid(); // console.log('sj ?? set Geometry cid:', cid, 'sid:', sid, "oindex:", oindex, "value:", value)


      _this.props.onChangeGeometry({
        cid: cid,
        sid: sid,
        gid: gid,
        gcid: gcid,
        oindex: oindex
      }, value); //draw done to drag 
      //this.setState({ drawingMode: "dragging" }) 
      //always redraw


      var drawingMode;

      if (_this.state.drawingMode != "dragging") {
        var type = _.get(_this.state.currentGeoItem, 'type');

        if (type) {
          if (type == "roi") {
            drawingMode = "polygon";
          } else {
            drawingMode = type;
          }
        }
      } else {
        drawingMode = "dragging";
      }

      _this.setState({
        drawingMode: drawingMode
      });

      _this.refreshConditionJson();
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          selectedCondition = _this$props.selectedCondition;
      selectedCondition.load();
      onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "checkTemperature", function () {
      var _this$state = _this.state,
          isDisplayInFahrenheitList = _this$state.isDisplayInFahrenheitList,
          currentGeoItem = _this$state.currentGeoItem;
      var pList = currentGeoItem.parameters;
      Object.keys(isDisplayInFahrenheitList).forEach(function (pid) {
        var isDisplayinFahrenheit = isDisplayInFahrenheitList[pid];

        if (isDisplayinFahrenheit) {
          var p = pList.find(function (p) {
            return p.attr.id === pid;
          });
          var value = convertToCelsius(p.value).toFixed(1);

          if (pid === "temperature_offset") {
            value = (p.value / 1.8).toFixed(1);
          }

          var pObj = {
            pid: pid,
            type: p.type,
            xmlObj: _.cloneDeep(p.xmlObj)
          };

          _this.handleParameter(pObj, value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSave", function () {
      _this.checkTemperature();

      _this.setState({
        isApplyLoading: true
      });

      _this.props.onSave().then(function () {
        _this.setState({
          isApplyLoading: false
        });

        _this.props.onClose();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeIsInvalid", function (gid, key, isInvalid) {
      _this.setState(function (prevS) {
        var i = _objectSpread({}, prevS.isInvalid);

        if (!isInvalid) {
          delete i[gid][key];

          if (Object.keys(i[gid]).length == 0) {
            delete i[gid];
          }
        } else {
          // i[gid][key] = isInvalid
          if (!i.hasOwnProperty(gid)) {
            i[gid] = {};
          }

          i[gid][key] = isInvalid;
        }

        return {
          isInvalid: i
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInvalid", function (gid, key, toBeInvalid) {
      var isInvalid = _.get(_this.state, "isInvalid.".concat(gid, ".").concat(key));

      if (!isInvalid) {
        if (toBeInvalid) {
          _this.changeIsInvalid(gid, key, true);
        }
      } else {
        if (!toBeInvalid) {
          _this.changeIsInvalid(gid, key, false);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "refreshConditionJson", function () {
      var cond = _this.getCurrentConditionItem();

      var _this$props$selectedC2 = _this.props.selectedCondition,
          cid = _this$props$selectedC2.cid,
          sid = _this$props$selectedC2.sid;
      var conditionJson = getConditionJson(cid, sid, cond);
      console.log('hl condition json: ', conditionJson);
      var currentGeoItem = _this.state.currentGeoItem;
      var currentGid = "condition_root";

      if (currentGeoItem) {
        currentGid = currentGeoItem.gid;
      }

      var geoItems = conditionJson.geoItems;
      var current = geoItems.find(function (item) {
        return item.gid == currentGid;
      }); // 支援多圖 geo-condition

      if (!current) {
        geoItems.map(function (it) {
          if (it.geoGroup) {
            current = it.geoGroup.find(function (it) {
              return it.gid == currentGid;
            });
          }
        });
      }

      _this.setState({
        conditionJson: conditionJson,
        currentGeoItem: current
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderParameterList", function (conditionItem) {
      var disable = _this.props.permissionDeny; // let c = conditionItem
      // if (!c) {
      //     c = this.getCurrentConditionItem()
      // }
      // const pList = this.getCurrentParameterList(c)

      var currentGeoItem = _this.state.currentGeoItem;
      var pList = currentGeoItem.parameters; // let pList = parameterList || this.getCurrentParameterList()

      console.log('sj pList', JSON.stringify(pList));

      if (window.isDev) {
        console.log('renderParameterList AnalyticalSetup', pList);
      }

      var filterForCondtion = function filterForCondtion(obj) {
        try {
          if (obj.type == 'title') {
            return true;
          }

          var hideItemsName = []; //['str_iod_show_area'] 
          // const trg = obj['$'].name
          // const vis = obj.$.visibility

          var trg = obj['attr'].name;
          var vis = obj.attr.visibility;

          if (vis == 'hidden' || vis == 'optional' && !_this.state.isShowAdvancedSettings) {
            return false;
          }

          return hideItemsName.filter(function (it) {
            return it === trg;
          }).length <= 0;
        } catch (error) {
          console.error('filter fail', error);
          return true;
        } // return it.$.visibility == 'hidden' || it.$.visibility == 'optional'

      };

      return pList.filter(filterForCondtion).sort(_this.sortCondItem).map(function (p) {
        // console.log('sj pItem', p, c)

        /* 
        p = {
            $: {
                default: "0",
                desc: "str_enable_desc",
                id: "enable",
                name: "str_enable",
                order: "1",
            }
            $type: "boolean"
            _: "1" 
        }
        */
        if (p.type == 'title') {
          var titleName = "parameter-title";
          return /*#__PURE__*/React.createElement("li", {
            className: "profile-item-dropdown " + titleName
          }, /*#__PURE__*/React.createElement("div", {
            className: titleName
          }, t("parameter_title_list." + p.attr.name)));
        }

        if (p.type == 'main_title') {
          var _titleName = "parameter-title";
          return /*#__PURE__*/React.createElement("li", {
            className: "profile-item-dropdown " + _titleName + " main"
          }, /*#__PURE__*/React.createElement("div", {
            className: _titleName
          }, t("parameter_title_list." + p.attr.name)));
        } // item name
        //let key = "parameter_list." + p.$.name


        var key = "parameter_list." + p.attr.name;
        var name = t(key);

        if (key == name) {
          // hl 無對應字串, 直接顯示名稱
          //name = p.$.name
          name = p.attr.name;
        } // if (getIsShowConditionParameterId()) {
        //     //name = _.get(p, '$.id')
        //     name = _.get(p, 'attr.id')
        // }
        // let value = p._
        // const id = p.$.id


        var value = p.value;
        var id = p.attr.id;
        var lng = _this.props.lng ? _this.props.lng : "en";
        var ivaDocFileName = _.get(p, 'attr.desc') + '_' + lng;
        var oldIvaDocFileName = 'help_' + id + '_' + lng;
        var ivaDocConfig = getConfig('envConfig.ivaDocs');

        var _getPath = function _getPath() {
          var o = _.get(ivaDocConfig, "".concat(ivaDocFileName), {});

          var ext = Object.keys(o);

          if (ext.length > 0) {
            var htm = ext.find(function (it) {
              return it == ".htm";
            });

            if (htm) {
              // if '.htm' exists 
              return o[htm];
            }

            return o[ext[0]];
          }

          return undefined;
        };

        var ivaDocPath = _getPath();

        if (ivaDocPath === undefined) {
          // @ Todo? when profiles all have desc for iva doc remove this part
          // if no iva doc found for desc field try to use pid to find old doc
          ivaDocPath = _.get(ivaDocConfig, "".concat(oldIvaDocFileName, "[\".htm\"]"));
        }

        var paramName = name;
        var haveIcon = false;

        if (!ivaDocPath) {
          name = /*#__PURE__*/React.createElement("div", null, " ", name, " ");
        } else {
          name = /*#__PURE__*/React.createElement("div", {
            className: "name"
          }, name, /*#__PURE__*/React.createElement(NewTabIcon, {
            icon: "ic icon-ic_help",
            url: "/assets/ivaDocs/" + ivaDocPath
          }));
          haveIcon = true;
        }

        var isSubParameter = false;

        if (p.xmlObj.length > 0) {
          isSubParameter = true;
        } // 2020/09/22: 若是從 geoCondition 內部圖型(單層圖、雙層圖)攤上來的參數 'attr.id' 數值可能會一樣, 造成參數欄位的提示異常!
        // 故需重新組合一把 'isInvalid' 的 key (issue #53515)


        var getGcInvalidId = function getGcInvalidId(p, id) {
          var list = [];

          if (p.xmlObj && _.isArray(p.xmlObj)) {
            list = p.xmlObj.map(function (it) {
              return it.gid;
            });
          }

          if (list.length > 0) {
            // 2020/09/22: 避免 lodash 處理的層數增加, 故不用 '.', 否則要修正 changeIsInvalid() 內部邏輯
            return "".concat(list.join('-'), "-").concat(id);
          } else {
            return id;
          }
        };

        var invalidId = getGcInvalidId(p, id); // create the component by item type
        // switch (p.$type) {

        switch (p.type) {
          case Parameter.BOOLEAN:
            value = value != "0";

            var onClickBoolean = function onClickBoolean() {
              var target = value ? "0" : "1";
              var pObj = {
                pid: id,
                type: p.type,
                xmlObj: _.cloneDeep(p.xmlObj)
              };

              _this.handleParameter(pObj, target);
            };

            return /*#__PURE__*/React.createElement("li", {
              className: cx("switch", {
                "disableCondition": disable,
                "sub-parameter": isSubParameter
              })
            }, name, /*#__PURE__*/React.createElement("div", {
              id: "subscribe1",
              className: "c-toggle-btn",
              onClick: onClickBoolean
            }, /*#__PURE__*/React.createElement("input", {
              type: "checkbox",
              checked: value
            }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
              for: "subscribe1",
              className: "on"
            }, t('on')), /*#__PURE__*/React.createElement("label", {
              for: "subscribe1",
              className: "off"
            }, t('off')), /*#__PURE__*/React.createElement("i", {
              className: "ic icon-ic_ridiobtn_fill "
            }))));
            break;

          case Parameter.FLOAT: // fall through

          case Parameter.INTEGER:
            // const defaultVal = _.get(p, '$.default')
            var defaultVal = _.get(p, 'attr.default');

            var parse = function parse(v) {
              //const par = _.get(p, '$type') == 'integer' ? parseInt : parseFloat
              var par = _.get(p, 'type') == 'integer' ? parseInt : parseFloat;
              var result = par(v); // hl, if value is Infinity/-Infinity, return 'NaN'
              // check string format

              if (typeof v === 'string') {
                if (v.match(/[0-9]+\.$/)) {
                  return v;
                }
              }

              if (result === 0) {
                if (typeof v === 'string') {
                  return v;
                }

                return 0;
              }

              return v;
            }; // const max = parse(_.get(p, '$.max_val', Infinity))
            // const min = parse(_.get(p, '$.min_val', -Infinity))
            // const step = _.get(p, '$type') == 'integer' ? 1 : 0.01


            var max = parse(_.get(p, 'attr.max_val', Infinity));
            var min = parse(_.get(p, 'attr.min_val', -Infinity));
            var step = _.get(p, 'type') == 'integer' ? 1 : 0.01;

            var isTemperatureField = function isTemperatureField(id) {
              var idArr = ["temperature_threshold", "temperature_offset"];
              return idArr.includes(id);
            };

            var isValidCheck = function isValidCheck(v) {
              if (!validateNumber(v, {
                digits: isTemperatureField(id) ? 1 : undefined,
                minus: id === "temperature_offset" ? true : false
              })) {
                return false;
              }

              var _v = v;

              if (typeof _v === 'string') {
                _v = parse(v);
              }

              var minCheck = true;
              var maxCheck = true;

              if (min !== undefined) {
                var _minVal = Number(min);

                if (id === "temperature_threshold" && _this.state.isDisplayInFahrenheitList[id]) {
                  _minVal = convertToFahrenheit(Number(min));
                }

                if (id === "temperature_offset" && _this.state.isDisplayInFahrenheitList[id]) {
                  _minVal = _minVal * 1.8;
                }

                minCheck = _v >= _minVal;
              }

              if (max !== undefined) {
                var _maxVal = Number(max);

                if (id === "temperature_threshold" && _this.state.isDisplayInFahrenheitList[id]) {
                  _maxVal = convertToFahrenheit(Number(max));
                }

                if (id === "temperature_offset" && _this.state.isDisplayInFahrenheitList[id]) {
                  _maxVal = _maxVal * 1.8;
                }

                maxCheck = _v <= _maxVal;
              } // console.log('sj??', {minCheck, maxCheck, _v, min, max})


              return minCheck && maxCheck; //return (!min || _v >= min) && (!max || _v <= max)
            }; // const isInvalid = _.get(this.state, `isInvalid.${currentGeoItem.gid}.${id}`)


            var isInvalid = _.get(_this.state, "isInvalid.".concat(currentGeoItem.gid, ".").concat(invalidId));

            var _onChange = function onChange(v) {
              // const v = _.get(e, 'target.value')
              var toBeInvalid = !isValidCheck(v);
              var pObj = {
                pid: id,
                type: p.type,
                xmlObj: _.cloneDeep(p.xmlObj)
              }; // this.handleInvalid(currentGeoItem.gid, id, toBeInvalid)

              _this.handleInvalid(currentGeoItem.gid, invalidId, toBeInvalid);

              _this.handleParameter(pObj, v);
            };

            var shouldRenderTemperatureDisplayToggle = function shouldRenderTemperatureDisplayToggle(pid) {
              var idArr = ["temperature_threshold", "temperature_offset"];
              return idArr.includes(pid);
            };

            var handleClickToggle = function handleClickToggle(e) {
              var _e$target$getBounding = e.target.getBoundingClientRect(),
                  left = _e$target$getBounding.left,
                  width = _e$target$getBounding.width;

              var x = e.clientX - left;
              var isSelectCelsius = x <= width / 2;
              var isSelectFahrenheit = x > width / 2;
              var isDisplayInFahrenheitList = _this.state.isDisplayInFahrenheitList;
              var shouldConvertToCelsius = isSelectCelsius && isDisplayInFahrenheitList[id];
              var shouldConvertToFahrenheit = isSelectFahrenheit && !isDisplayInFahrenheitList[id];

              if (shouldConvertToCelsius) {
                if (id === "temperature_offset") {
                  value = (value / 1.8).toFixed(1);
                } else {
                  value = convertToCelsius(value).toFixed(1);
                }

                var pObj = {
                  pid: id,
                  type: p.type,
                  xmlObj: _.cloneDeep(p.xmlObj)
                };

                _this.handleParameter(pObj, value);

                _this.setState({
                  isDisplayInFahrenheitList: _objectSpread(_objectSpread({}, isDisplayInFahrenheitList), {}, _defineProperty({}, id, false))
                });
              } else if (shouldConvertToFahrenheit) {
                if (id === "temperature_offset") {
                  value = (value * 1.8).toFixed(1);
                } else {
                  value = convertToFahrenheit(value).toFixed(1);
                }

                var _pObj = {
                  pid: id,
                  type: p.type,
                  xmlObj: _.cloneDeep(p.xmlObj)
                };

                _this.handleParameter(_pObj, value);

                _this.setState({
                  isDisplayInFahrenheitList: _objectSpread(_objectSpread({}, isDisplayInFahrenheitList), {}, _defineProperty({}, id, true))
                });
              }
            };

            var toggleDisabled = false;

            if (!validateNumber(value, {
              digits: isTemperatureField(id) ? 1 : undefined,
              minus: id === "temperature_offset" ? true : false
            })) {
              toggleDisabled = true;
            }

            return /*#__PURE__*/React.createElement("li", {
              className: cx("profile-item-dropdown", {
                "disableCondition": disable,
                "sub-parameter": isSubParameter
              })
            }, name, /*#__PURE__*/React.createElement("div", {
              className: "input-area"
            }, /*#__PURE__*/React.createElement(ValidInput, {
              className: "short",
              value: value,
              onChange: function onChange(v) {
                return _onChange(parse(v));
              },
              validator: function validator(isChanged, v) {
                var _min = min;
                var _max = max;

                if (id === "temperature_threshold" && _this.state.isDisplayInFahrenheitList[id]) {
                  _min = convertToFahrenheit(Number(min));
                  _max = convertToFahrenheit(Number(max));
                }

                if (id === "temperature_offset" && _this.state.isDisplayInFahrenheitList[id]) {
                  _min = (Number(min) * 1.8).toFixed(1);
                  _max = (Number(max) * 1.8).toFixed(1);
                }

                var _msg = "".concat(t('valueShouldIn'), ": ").concat(_min, " ~ ").concat(_max);

                if (!validateNumber(v, {
                  digits: isTemperatureField(id) ? 1 : undefined,
                  minus: id === "temperature_offset" ? true : false
                })) {
                  if (isTemperatureField(id)) {
                    _msg = t('shanyCameraSetting.invalid-float-msg');
                  } else {
                    _msg = t('invalidValue');
                  }
                }

                return {
                  isError: isInvalid,
                  msg: _msg
                };
              }
            }), shouldRenderTemperatureDisplayToggle(p.attr.id) && /*#__PURE__*/React.createElement(TemperatureConverterToggle, {
              isDisplayInFahrenheit: _this.state.isDisplayInFahrenheitList[id],
              onClick: toggleDisabled ? null : handleClickToggle,
              disabled: toggleDisabled
            })));

          case Parameter.RADIO:
            {
              try {
                var onChangeRadio = function onChangeRadio(e) {
                  var _value = {
                    $custom: "radio",
                    value: e.target.value
                  };
                  var pObj = {
                    pid: id,
                    type: p.type,
                    xmlObj: _.cloneDeep(p.xmlObj)
                  };

                  _this.handleParameter(pObj, _value);
                };

                var handleChangeSelected = function handleChangeSelected(v) {
                  var _value = {
                    $custom: "radio",
                    value: v
                  };
                  var pObj = {
                    pid: id,
                    type: p.type,
                    xmlObj: _.cloneDeep(p.xmlObj)
                  };

                  _this.handleParameter(pObj, _value);
                };

                var defaultId,
                    selectedIdx = 0;
                value = undefined; // let items = p.option_list[0].option

                var items = p.options[0].option.filter(filterForCondtion).map(function (op, index) {
                  // let optionkey = "parameter_list." + op.$.name;
                  var optionkey = "parameter_list." + op.attr.name;
                  var optionName = t(optionkey); //console.log(`hl key: ${key}, value: ${optionName}`)

                  if (optionkey == optionName) {
                    // hl 無對應字串, 直接顯示名稱
                    // optionName = op.$.name;
                    optionName = op.attr.name;
                  } // if (op.$.default == "1") {
                  //     defaultId = op.$.id
                  // }
                  // if (op._ == "1") {
                  //     value = op.$.id
                  //     selectedIdx = index
                  // }


                  if (op.attr.default == "1") {
                    defaultId = op.attr.id;
                  }

                  if (op.value == "1") {
                    value = op.attr.id;
                    selectedIdx = index;
                  } // return <option value={op.$.id}>{optionName}</option>
                  //console.log('hl index: ', index, ', text: ', optionName)
                  // return { value: op.$.id, text: optionName }


                  return {
                    value: op.attr.id,
                    text: optionName
                  };
                });

                if (!value) {
                  value = defaultId;
                } //console.log('hl index: ', selectedIdx)
                // [
                // // let items = [
                //     <option value={1}>1</option>,
                //     <option value={2}>2</option>
                //     ]


                return /*#__PURE__*/React.createElement("li", {
                  className: cx("profile-item-dropdown", {
                    "disableCondition": disable,
                    "sub-parameter": isSubParameter
                  })
                }, name, /*#__PURE__*/React.createElement("div", {
                  className: "profile-item-wrapper arrow"
                }, /*#__PURE__*/React.createElement(DropList, {
                  selected: value,
                  scrollToIndex: selectedIdx,
                  list: items,
                  onChangeSelected: function onChangeSelected(v) {
                    handleChangeSelected(v);
                  }
                })));
              } catch (error) {
                console.error('render radio fail', error);
              }

              break;
            }

          case Parameter.DYNAMIC_RADIO:
            {
              try {
                var _handleChangeSelected = function _handleChangeSelected(v) {
                  var _value = {
                    $custom: "dynamic_radio",
                    value: v
                  };
                  var pObj = {
                    pid: id,
                    type: p.type,
                    xmlObj: _.cloneDeep(p.xmlObj)
                  };

                  _this.handleParameter(pObj, _value);
                }; // return null
                // 選擇處理器


                return /*#__PURE__*/React.createElement("li", {
                  className: cx("profile-item-dropdown", {
                    "disableCondition": disable,
                    "sub-parameter": isSubParameter
                  })
                }, name, /*#__PURE__*/React.createElement("div", {
                  className: "profile-item-wrapper arrow"
                }, /*#__PURE__*/React.createElement(DynamicRadio, {
                  param: p,
                  onChangeSelected: _handleChangeSelected
                })));
              } catch (error) {
                console.error('render dynamic radio fail', error);
              }

              break;
            }

          case Parameter.MULTI_SELECTION:
            {
              try {
                // const name = ''
                var options = _.get(p, 'options[0].option') || [];

                var _items = options.filter(filterForCondtion).sort(_this.sortCondItem).map(function (op) {
                  // let oKey = "parameter_list." + op.$.name
                  var oKey = "parameter_list." + op.attr.name;
                  var oName = t(oKey);

                  if (oName == oKey) {
                    // hl 無對應字串, 直接顯示名稱
                    // oName = op.$.name
                    oName = op.attr.name;
                  } // const oid = op.$.id
                  // let isCheck = op._ == "1" || (op._ === undefined && op.$.default == "1")


                  var oid = op.attr.id;
                  var isCheck = op.value == "1" || op.value === undefined && op.attr.default == "1";

                  var onChangeOption = function onChangeOption() {
                    var _value = {
                      $custom: "multi_selection",
                      options: _defineProperty({}, oid, !isCheck)
                    };
                    var pObj = {
                      pid: id,
                      type: p.type,
                      xmlObj: _.cloneDeep(p.xmlObj)
                    };

                    _this.handleParameter(pObj, _value);
                  };

                  return /*#__PURE__*/React.createElement("div", {
                    className: cx("g-checkbox", {
                      "disableCondition": disable
                    })
                  }, /*#__PURE__*/React.createElement("input", {
                    id: oid,
                    type: "checkbox",
                    onChange: onChangeOption,
                    checked: isCheck
                  }), /*#__PURE__*/React.createElement("label", {
                    htmlFor: oid
                  }, oName));
                });

                return /*#__PURE__*/React.createElement("li", {
                  className: cx("profile-item-dropdown multiSelect", {
                    "disableCondition": disable,
                    "sub-parameter": isSubParameter
                  })
                }, /*#__PURE__*/React.createElement("div", {
                  className: "title"
                }, name), _items);
              } catch (error) {
                console.error('render multi selection fail', error);
              }

              break;
            }

          case Parameter.MULTI_STRING:
            var onChangeMultiStr = function onChangeMultiStr(v) {
              console.log("kz multi_string onChangeMultiStr", v); // this.multiStrParams[id] = { value: v }

              var toBeInvalid = _this.checkAMultiStrParamInvalid(v);

              var pObj = {
                pid: id,
                type: p.type,
                xmlObj: _.cloneDeep(p.xmlObj)
              };
              var _value = {
                $custom: "multi_string",
                strings: v
              }; // this.handleInvalid(currentGeoItem.gid, id, toBeInvalid)

              _this.handleInvalid(currentGeoItem.gid, invalidId, toBeInvalid);

              _this.handleParameter(pObj, _value);
            }; // const strings = _.get(p, 'string_list[0].string') || []


            var strings = _.get(p, 'strings[0].string') || []; // this.multiStrParams[id] = { value: strings }

            return /*#__PURE__*/React.createElement("li", {
              className: cx("profile-item-dropdown", {
                "disableCondition": disable,
                "sub-parameter": isSubParameter
              })
            }, name, /*#__PURE__*/React.createElement("span", {
              className: "c-combobox multi-input"
            }, /*#__PURE__*/React.createElement(MultiInput, {
              base: ValidInput,
              props: {
                validator: function validator(isChanged, v) {
                  if (typeof v == 'string') {
                    v = v.trim();
                  }

                  if (!v) {
                    return {
                      isError: true,
                      msg: "".concat(paramName).concat(t('parameter-is-empty'))
                    };
                  }

                  return {
                    isError: false,
                    msg: ''
                  };
                }
              },
              inline: true,
              value: strings,
              onChange: onChangeMultiStr
            })));
            break;

          case Parameter.STRING:
          default:
            {
              // const maxLen = parseInt(_.get(p, '$.max_len')) || Infinity
              // const minLen = parseInt(_.get(p, '$.min_len')) || (-Infinity)
              var maxLen = parseInt(_.get(p, 'attr.max_len')) || Infinity;
              var minLen = parseInt(_.get(p, 'attr.min_len')) || -Infinity;

              var _isValidCheck = function _isValidCheck(v) {
                return v.length <= maxLen && v.length >= minLen;
              };

              var isBlankOrEmptyCheck = function isBlankOrEmptyCheck(v) {
                if (typeof v == 'string') {
                  v = v.trim();
                }

                if (!v) {
                  return true;
                } else {
                  return false;
                }
              }; // const isInvalid = _.get(this.state, `isInvalid.${currentGeoItem.gid}.${id}`)


              var _isInvalid = _.get(_this.state, "isInvalid.".concat(currentGeoItem.gid, ".").concat(invalidId));

              var onChangeStr = function onChangeStr(v) {
                var toBeInvalid = !_isValidCheck(v) || isBlankOrEmptyCheck(v);
                var pObj = {
                  pid: id,
                  type: p.type,
                  xmlObj: _.cloneDeep(p.xmlObj)
                }; // this.handleInvalid(currentGeoItem.gid, id, toBeInvalid)

                _this.handleInvalid(currentGeoItem.gid, invalidId, toBeInvalid);

                _this.handleParameter(pObj, v);
              };

              return /*#__PURE__*/React.createElement("li", {
                className: cx("profile-item-dropdown", {
                  "disableCondition": disable,
                  "sub-parameter": isSubParameter
                })
              }, name, /*#__PURE__*/React.createElement(ValidInput, {
                className: "short",
                value: value,
                onChange: onChangeStr,
                validator: function validator(isChanged, v) {
                  var errMsg = '';

                  if (_isInvalid) {
                    errMsg = "".concat(t('length-should-in'), " ").concat(minLen, " ~ ").concat(maxLen);

                    if (isBlankOrEmptyCheck(v)) {
                      errMsg = "".concat(paramName).concat(t('parameter-is-empty'));
                    }
                  }

                  return {
                    isError: _isInvalid,
                    msg: errMsg
                  };
                }
              }));
            }
            break;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkMultiStrParamsInvalid", function () {
      var pidList = Object.keys(_this.multiStrParams);
      var isInvalid = false;

      if (pidList.length > 0) {
        pidList.map(function (pid) {
          var param = _this.multiStrParams[pid]; // check content

          if (!param.value || param.value.length == 0) {
            isInvalid = true;
            return;
          }

          param.value.map(function (item) {
            if (!item || !item.trim()) {
              isInvalid = true;
              return;
            }
          });
        });
      }

      return isInvalid;
    });

    _defineProperty(_assertThisInitialized(_this), "checkAMultiStrParamInvalid", function (val) {
      var isInvalid = false;

      if (!val) {
        return true;
      }

      if (val.length == 0) {
        isInvalid = true;
      } else {
        val.map(function (item) {
          if (typeof item == 'string') {
            item = item.trim();
          }

          if (!item) {
            isInvalid = true;
            return;
          }
        });
      }

      return isInvalid;
    });

    _defineProperty(_assertThisInitialized(_this), "getGraphName", function (key) {
      try {
        //console.log('hl graphic key: ', key.replace(/\d*/g, ''))
        var k = key.replace(/\d*/g, '');

        if (graphicPrefix.hasOwnProperty(k)) {
          var prefix = graphicPrefix[k];

          if (key.indexOf(prefix) >= 0) {
            var startIdx = key.indexOf(prefix);
            return t("graph.".concat(prefix)) + key.substring(startIdx + prefix.length);
          }
        } else {
          return key;
        }
      } catch (error) {
        console.error('getGraphName fail', error);
        return key;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderGraphItems", function () {
      var graphItems = [];
      var _this$state2 = _this.state,
          conditionJson = _this$state2.conditionJson,
          currentGeoItem = _this$state2.currentGeoItem,
          isInvalid = _this$state2.isInvalid;
      var errIcon = /*#__PURE__*/React.createElement("i", {
        className: "ic icon-ic_alert_1 error"
      }); // get the <li>'s content that contains a main icon, a graph name and the optional error icon

      var getLiContent = function getLiContent(icon, name, isError) {
        var items = [];
        items.push(icon);
        items.push(name);

        if (isError) {
          items.push(errIcon);
        }

        return items;
      }; // 支援多圖的 geo-condition 的呈現: isGeoGroupItem


      var renderLi = function renderLi(_ref2) {
        var isSelected = _ref2.isSelected,
            isError = _ref2.isError,
            drawingMode = _ref2.drawingMode,
            currentGeoItem = _ref2.currentGeoItem,
            content = _ref2.content,
            isGeoGroupItem = _ref2.isGeoGroupItem;
        var isGeoItem = currentGeoItem.type !== '@root';

        var getItemType = function getItemType(isGeoItem, isGeoGroupItem) {
          var type = '';
          if (isGeoItem) type = 'geo-item';
          if (isGeoGroupItem) type = 'geo-group'; // 多圖

          return type;
        };

        var itemType = getItemType(isGeoItem, isGeoGroupItem); // 支援多圖 geo-condition

        var gcid = currentGeoItem.isGeoCondition ? _.get(currentGeoItem, 'gid') : undefined;

        if (isGeoGroupItem) {
          gcid = currentGeoItem.parent;
        }

        return /*#__PURE__*/React.createElement("li", {
          onClick: isSelected ? null : function () {
            var targetMap = {
              '@root': 'display',
              '@geoGroup': 'display'
            };
            var type = currentGeoItem.type;
            var targetType = targetMap[type] || type;

            var cid = _.get(conditionJson, 'cid');

            var sid = _.get(conditionJson, 'sid'); // const gcid = currentGeoItem.isGeoCondition ? _.get(currentGeoItem, 'gid') : undefined


            var gid = _.get(currentGeoItem, 'value.$.id');

            var arrow = _.get(currentGeoItem, 'value.$.arrow') === "1";

            var startPointColor = _.get(currentGeoItem, 'value.$.start_point_color', null);

            var target = {
              type: targetType,
              cid: cid,
              sid: sid,
              gcid: gcid,
              gid: gid,
              arrow: arrow,
              startPointColor: startPointColor
            }; // console.log('sj ??', currentGeoItem, conditionJson)

            drawingToolApp.changeTarget(target, _this.renderGeoObjs({
              currentGeoItem: currentGeoItem
            }));

            _this.setState({
              drawingMode: drawingMode,
              isErase: false,
              currentGeoItem: currentGeoItem
            });
          },
          className: cx(itemType, {
            "select": isSelected,
            "error": isError
          })
        }, content);
      };

      conditionJson.geoItems.map(function (item, index) {
        var isSelected = false; // console.log('hl root item: ', item, ', current: ', currentGeoItem)

        if (currentGeoItem && item.gid == currentGeoItem.gid && item.parent == currentGeoItem.parent) {
          isSelected = true;
        }

        var isError = Object.keys(isInvalid).indexOf(item.gid) > -1; // root

        if (item.type == "@root") {
          var content = getLiContent( /*#__PURE__*/React.createElement("i", {
            className: "fas fa-cog"
          }), _this.getCurrentConditionItemName(), isError);
          graphItems.push(renderLi({
            isSelected: isSelected,
            isError: isError,
            drawingMode: "dragging",
            currentGeoItem: item,
            content: content
          }));
        } else {
          if (item.isGeoCondition) {
            if (item.geoGroup.length > 0) {
              var key = item.gid;
              var iconClassName = "ic ".concat(graphicIconMap['geoGroup']);
              var iconDom = /*#__PURE__*/React.createElement("i", {
                className: iconClassName
              });
              if (graphicIconMap['geoGroup'] === 'icon-ic_path_polyline') iconDom = /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(TimelineIcon, null));

              var _content = getLiContent(iconDom, _this.getGraphName(key), isError);

              graphItems.push(renderLi({
                isSelected: isSelected,
                isError: isError,
                drawingMode: 'dragging',
                currentGeoItem: item,
                content: _content
              }));
              item.geoGroup.map(function (group) {
                var isGroupSelected = false;

                if (currentGeoItem && group.gid == currentGeoItem.gid && group.parent == currentGeoItem.parent) {
                  isGroupSelected = true;
                }

                var geom = group.value;
                var key = group.gid;
                var iconClassName = "ic ".concat(graphicIconMap[group.type]);
                var drawingMode = geom.$type == "roi" ? "polygon" : geom.$type;
                var iconDom = /*#__PURE__*/React.createElement("i", {
                  className: iconClassName
                });
                if (graphicIconMap[group.type] === 'icon-ic_path_polyline') iconDom = /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(TimelineIcon, null));
                var content = getLiContent(iconDom, _this.getGraphName(key), isError);
                graphItems.push(renderLi({
                  isSelected: isGroupSelected,
                  isError: isError,
                  drawingMode: drawingMode,
                  currentGeoItem: group,
                  content: content,
                  isGeoGroupItem: true
                }));
              });
            } else {
              var geom = item.value;
              var _key2 = item.gid;

              var _iconClassName = "ic ".concat(graphicIconMap[item.type]);

              var _iconDom = /*#__PURE__*/React.createElement("i", {
                className: _iconClassName
              });

              if (graphicIconMap[item.type] === 'icon-ic_path_polyline') _iconDom = /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(TimelineIcon, null));
              var drawingMode = geom.$type == "roi" ? "polygon" : geom.$type;

              var _content2 = getLiContent(_iconDom, _this.getGraphName(_key2), isError);

              graphItems.push(renderLi({
                isSelected: isSelected,
                isError: isError,
                drawingMode: drawingMode,
                currentGeoItem: item,
                content: _content2
              }));
            }
          } else {
            var _geom = item.value;
            var _key3 = item.gid;

            var _iconClassName2 = "ic ".concat(graphicIconMap[_geom.$type]);

            var _iconDom2 = /*#__PURE__*/React.createElement("i", {
              className: _iconClassName2
            });

            if (graphicIconMap[_geom.$type] === 'icon-ic_path_polyline') _iconDom2 = /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(TimelineIcon, null));

            var _drawingMode = _geom.$type == "roi" ? "polygon" : _geom.$type;

            var _content3 = getLiContent(_iconDom2, _this.getGraphName(_key3), isError);

            graphItems.push(renderLi({
              isSelected: isSelected,
              isError: isError,
              drawingMode: _drawingMode,
              currentGeoItem: item,
              content: _content3
            }));
          }
        }
      });
      return graphItems; // return
      // return [
      //     <li className="select"><i className="ic icon-ic_eye"></i>ROI 01</li>
      //     , <li><i className="ic icon-ic_eye"></i>ROI 02</li>
      //     , <li className="layer"><i className="ic icon-ic_path_region"></i>icon-ic_path_region</li>
      //     , <li className="layer"><i className="ic icon-ic_path_line"></i>icon-ic_path_line</li>
      //     , <li className="layer"><i className="ic icon-ic_path_direction"></i>icon-ic_path_direction</li>
      //     , <li><i className="ic icon-ic_eye"></i>ROI 03</li>
      //     , <li><i className="ic icon-ic_eye"></i>ROI 04</li>
      //     , <li><i className="ic icon-ic_eye_2"></i>ROI 05</li>
      // ]
    });

    _defineProperty(_assertThisInitialized(_this), "getGeoObjs", function () {
      var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var opacity = arguments.length > 1 ? arguments[1] : undefined;
      var geo = geometry;

      var objCount = _this.props.selectedCondition.getObjectCount({
        geometry: geo
      });

      return getDrawingObjs(objCount, geo, opacity);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToolMouseEnter", function (e) {
      switch (e.target.id) {
        case 'eraser':
          _this.setState({
            showPermissionDenyTip: {
              eraser: true
            }
          });

          break;

        case 'mouse':
          _this.setState({
            showPermissionDenyTip: {
              mouse: true
            }
          });

          break;

        case 'graphic':
          _this.setState({
            showPermissionDenyTip: {
              graphic: true
            }
          });

          break;

        case 'edit':
          _this.setState({
            showPermissionDenyTip: {
              edit: true
            }
          });

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToolMouseLeave", function (e) {
      switch (e.target.id) {
        case 'eraser':
          _this.setState({
            showPermissionDenyTip: {
              eraser: false
            }
          });

          break;

        case 'mouse':
          _this.setState({
            showPermissionDenyTip: {
              mouse: false
            }
          });

          break;

        case 'graphic':
          _this.setState({
            showPermissionDenyTip: {
              graphic: false
            }
          });

          break;

        case 'edit':
          _this.setState({
            showPermissionDenyTip: {
              edit: false
            }
          });

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateImage", function () {
      _this.appKey = "snapshot_ch" + _this.props.channel + '_' + new Date().toISOString();
      var imgUrl = _this.props.imgUrl + '&chKey=' + _this.appKey;

      _this.setState({
        imgUrl: imgUrl
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isParameterValid", function (isInvalidObj) {
      var _i = isInvalidObj || _this.state.isInvalid;

      return Object.keys(_i).map(function (k) {
        return _i[k];
      }).filter(function (it) {
        return it;
      }).length == 0;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickEditPolylinPair", function () {
      drawingToolApp.clickEdit();

      _this.setState({
        drawingMode: 'edit',
        isErase: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDrawingToolButton", function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref3.id,
          icon = _ref3.icon,
          onClick = _ref3.onClick,
          isSelect = _ref3.isSelect,
          disable = _ref3.disable,
          showTip = _ref3.showTip;

      var iconDom = /*#__PURE__*/React.createElement("i", {
        id: id,
        className: "ic " + icon,
        onMouseEnter: _this.handleToolMouseEnter,
        onMouseLeave: _this.handleToolMouseLeave
      });
      if (icon === 'icon-ic_path_polyline') iconDom = /*#__PURE__*/React.createElement(TimelineIcon, {
        id: id,
        onMouseEnter: _this.handleToolMouseEnter,
        onMouseLeave: _this.handleToolMouseLeave
      });
      return /*#__PURE__*/React.createElement("li", {
        onClick: onClick,
        className: cx({
          select: isSelect
        }, {
          notAllowRoiTool: disable
        })
      }, iconDom, showTip ? /*#__PURE__*/React.createElement("div", {
        id: "btn-NoRight",
        className: "left"
      }, t("notAllow")) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDrawingTool", function (isGeometry) {
      if (!isGeometry) {
        return null;
      }

      var _this$state3 = _this.state,
          showPermissionDenyTip = _this$state3.showPermissionDenyTip,
          currentGeoItem = _this$state3.currentGeoItem;

      var curGeoType = _.get(currentGeoItem, 'type');

      if (['@root', '@geoGroup'].indexOf(curGeoType) > -1) {
        return null;
      }

      var disable = _this.props.permissionDeny;
      var drawMode = null;
      var editMode = null; // graphic

      if (curGeoType) {
        var dm = curGeoType;

        if (curGeoType == "roi") {
          dm = "polygon";
        }

        var clickDraw = function clickDraw() {
          if (disable || _this.state.isDrawing) {
            return;
          }

          drawingToolApp.clickDraw();

          _this.setState({
            drawingMode: dm,
            isErase: false
          });
        };

        drawMode = _this.renderDrawingToolButton({
          id: "graphic",
          icon: graphicIconMap[dm],
          onClick: clickDraw,
          isSelect: _this.state.drawingMode == dm,
          disable: disable,
          showTip: disable && showPermissionDenyTip["graphic"]
        });

        if (curGeoType == "polyline_pair") {
          editMode = _this.renderDrawingToolButton({
            id: "edit",
            icon: "icon-ic_draw_dote",
            onClick: _this.handleClickEditPolylinPair,
            isSelect: _this.state.drawingMode == 'edit',
            disable: disable,
            showTip: disable && showPermissionDenyTip["edit"]
          });
        }
      }

      return /*#__PURE__*/React.createElement("ul", {
        className: cx("ROI-tool-box")
      }, drawMode, editMode, /*#__PURE__*/React.createElement("li", {
        onClick: function onClick() {
          if (disable || _this.state.isDrawing) {
            return;
          }

          ;
          drawingToolApp.clickDrag();

          _this.setState({
            drawingMode: "dragging",
            isErase: false
          });
        },
        className: cx({
          select: _this.state.drawingMode == "dragging" && _this.state.isErase == false
        }, {
          "notAllowRoiTool": disable,
          "drawing": _this.state.isDrawing
        })
      }, /*#__PURE__*/React.createElement("i", {
        id: "mouse",
        className: "fas fa-mouse-pointer",
        onMouseEnter: _this.handleToolMouseEnter,
        onMouseLeave: _this.handleToolMouseLeave
      }), disable && showPermissionDenyTip['mouse'] ? /*#__PURE__*/React.createElement("div", {
        id: "btn-NoRight",
        className: "left"
      }, t("notAllow")) : null), /*#__PURE__*/React.createElement("li", {
        onClick: function onClick() {
          if (disable || _this.state.isDrawing) {
            return;
          }

          ;
          drawingToolApp.clickErase();

          _this.setState({
            drawingMode: "dragging",
            isErase: true
          });
        },
        className: cx({
          select: _this.state.isErase == true
        }, {
          "notAllowRoiTool": disable,
          "drawing": _this.state.isDrawing
        })
      }, /*#__PURE__*/React.createElement("i", {
        id: "eraser",
        className: "fas fa-eraser",
        onMouseEnter: _this.handleToolMouseEnter,
        onMouseLeave: _this.handleToolMouseLeave
      }), disable && showPermissionDenyTip['eraser'] ? /*#__PURE__*/React.createElement("div", {
        id: "btn-NoRight",
        className: "left"
      }, t("notAllow")) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderGeoObjs", function () {
      var newParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$state4 = _this.state,
          conditionJson = _this$state4.conditionJson,
          currentGeoItem = _this$state4.currentGeoItem;

      if (newParams.conditionJson !== undefined) {
        conditionJson = newParams.conditionJson;
      }

      if (newParams.currentGeoItem !== undefined) {
        currentGeoItem = newParams.currentGeoItem;
      }

      var curGeoType = currentGeoItem.type;
      var drawObj = [];

      if (curGeoType === '@root') {
        drawObj = [];
        conditionJson.geoItems.map(function (geoItem) {
          if (geoItem.type === '@root') {
            return;
          }

          if (geoItem.type === '@geoGroup') {
            var geos = _.get(geoItem, 'geoGroup', []);

            geos.map(function (geo) {
              _this.getGeoObjs(geo.value).map(function (it) {
                it.id = _.get(geo, 'attr.id') + '_' + it.id;
                drawObj.push(it);
              });
            });
          }

          _this.getGeoObjs(geoItem.value).map(function (it) {
            if (geoItem.isGeoCondition) {
              // deal for geometry id duplicate cross geo condition
              it.id = _.get(geoItem, 'attr.id') + '_' + it.id;
              it.tagName = _this.getGraphName(_.get(geoItem, 'gid'));
            }

            drawObj.push(it);
          });
        });
      } else if (curGeoType === '@geoGroup') {
        drawObj = [];

        var geos = _.get(currentGeoItem, "geoGroup", []);

        geos.map(function (geo) {
          _this.getGeoObjs(geo.value).map(function (it) {
            return drawObj.push(it);
          });
        });
      } else {
        drawObj = []; // currentGeoItem.value

        _this.getGeoObjs(currentGeoItem.value).map(function (it) {
          return drawObj.push(it);
        });
      }

      console.log("sj gList", currentGeoItem, drawObj, conditionJson);
      var targetMap = {
        '@root': 'display',
        '@geoGroup': 'display'
      }; //drawingToolApp.changeTarget(targetMap[curGeoType] || curGeoType, drawObje)

      return drawObj;
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditStart", function () {
      _this.setState({
        isDrawing: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditEnd", function () {
      _this.setState({
        isDrawing: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      _this.isInitialing = false;
    });

    return _this;
  }

  _createClass(ConditionSetupPopup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.init();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var selectedCondition = this.props.selectedCondition;
      selectedCondition.save();
      this.drawingToolAutoResize();
      drawingToolApp.setCallback({
        onReady: function onReady() {
          var _this2$state = _this2.state,
              currentGeoItem = _this2$state.currentGeoItem,
              conditionJson = _this2$state.conditionJson;
          var targetMap = {
            '@root': 'display',
            '@geoGroup': 'display'
          };
          var type = currentGeoItem.type;
          var targetType = targetMap[type] || type;

          var cid = _.get(conditionJson, 'cid');

          var sid = _.get(conditionJson, 'sid');

          var gcid = currentGeoItem.isGeoCondition ? _.get(currentGeoItem, 'gid') : undefined;

          if (currentGeoItem.isGeoCondition && currentGeoItem.geoGroup.length > 0) {
            gcid = currentGeoItem.parent;
          }

          var gid = _.get(currentGeoItem, 'value.$.id');

          var arrow = _.get(currentGeoItem, 'value.$.arrow') === "1";

          var startPointColor = _.get(currentGeoItem, 'value.$.start_point_color', null);

          var target = {
            type: targetType,
            cid: cid,
            sid: sid,
            gcid: gcid,
            gid: gid,
            arrow: arrow,
            startPointColor: startPointColor
          };
          drawingToolApp.changeTarget(target, _this2.renderGeoObjs({
            currentGeoItem: currentGeoItem
          }));
        },
        setGeometry: this.setGeometry
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopCanvasResize();
    }
  }, {
    key: "renderDrawingToolView",
    value: function renderDrawingToolView() {
      var _this3 = this;

      var _this$state5 = this.state,
          conditionJson = _this$state5.conditionJson,
          currentGeoItem = _this$state5.currentGeoItem,
          imgUrl = _this$state5.imgUrl;
      var curGeoType = currentGeoItem.type;
      var drawObj = [];

      if (curGeoType === '@root') {
        drawObj = [];
        conditionJson.geoItems.map(function (geoItem) {
          if (geoItem.type === '@root') {
            return;
          }

          if (geoItem.type === '@geoGroup') {
            var geos = _.get(geoItem, 'geoGroup', []);

            geos.map(function (geo) {
              _this3.getGeoObjs(geo.value).map(function (it) {
                it.id = _.get(geo, 'attr.id') + '_' + it.id;
                drawObj.push(it);
              });
            });
          }

          _this3.getGeoObjs(geoItem.value).map(function (it) {
            if (geoItem.isGeoCondition) {
              // deal for geometry id duplicate cross geo condition
              it.id = _.get(geoItem, 'attr.id') + '_' + it.id;
            }

            drawObj.push(it);
          });
        });
      } else if (curGeoType === '@geoGroup') {
        drawObj = [];

        var geos = _.get(currentGeoItem, "geoGroup", []);

        geos.map(function (geo) {
          _this3.getGeoObjs(geo.value).map(function (it) {
            return drawObj.push(it);
          });
        });
      } else {
        drawObj = []; // currentGeoItem.value

        this.getGeoObjs(currentGeoItem.value).map(function (it) {
          return drawObj.push(it);
        });
      }

      console.log("kz gList", currentGeoItem, drawObj, conditionJson);
      return /*#__PURE__*/React.createElement(DrawingToolView, {
        id: "conditionPop",
        key: this.appKey || "-----",
        url: imgUrl,
        width: this.state.width,
        height: this.state.height,
        supportPercentage: this.props.supportPercentage,
        onEditStart: this.handleEditStart,
        onEditEnd: this.handleEditEnd,
        onReady: this.handleReady
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var onClose = this.props.onClose;
      var _this$state6 = this.state,
          conditionJson = _this$state6.conditionJson,
          currentGeoItem = _this$state6.currentGeoItem;
      var isGeometry = false;

      if (conditionJson.geoItems.length > 0) {
        isGeometry = true;
      }

      var isDisableSubmit = !this.isParameterValid();
      return /*#__PURE__*/React.createElement("div", {
        id: "g-profile-setting"
      }, /*#__PURE__*/React.createElement("div", {
        id: "g-popup-container"
      }, /*#__PURE__*/React.createElement("section", {
        "data-reactroot": "",
        className: "c-modal show c-center global"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }), /*#__PURE__*/React.createElement("section", {
        id: "undefined-dialog",
        className: "c-box dialog react-draggable purple "
      }, /*#__PURE__*/React.createElement("header", {
        className: "handle c-flex"
      }, this.getCurrentConditionItemName(), /*#__PURE__*/React.createElement("i", {
        onClick: this.handleCancel,
        className: "c-link fg fg-close end ic icon-ic_close"
      })), /*#__PURE__*/React.createElement("div", {
        id: "undefined-content",
        className: "content pure-form"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "menu-left  custom-scroll"
      }, /*#__PURE__*/React.createElement("p", null, t('analytic-setup.sourceTypeChannel'), /*#__PURE__*/React.createElement("br", null), this.props.channelName), !isGeometry ? /*#__PURE__*/React.createElement("p", {
        className: "explain"
      }, t('analytic-setup.noGraphic')) : this.renderGraphItems()), /*#__PURE__*/React.createElement("div", {
        className: "content-middle"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "switch-box"
      }, /*#__PURE__*/React.createElement("li", {
        onClick: this.updateImage
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-camera"
      }))), this.renderDrawingTool(isGeometry), /*#__PURE__*/React.createElement("div", {
        id: "DrawingToolAppBox",
        className: cx("ROI-bord", {
          "notAllowDraw": this.props.permissionDeny
        })
      }, this.state.graphSizeReady ? this.renderDrawingToolView() : null)), this.props.permissionDeny ? /*#__PURE__*/React.createElement("div", {
        className: "noRight",
        onMouseEnter: function onMouseEnter() {
          _this4.setState({
            showPermissionDenyTip: {
              condPanel: true
            }
          });
        },
        onMouseLeave: function onMouseLeave() {
          _this4.setState({
            showPermissionDenyTip: {
              condPanel: false
            }
          });
        },
        onClick: function onClick() {
          _this4.setState({
            showPermissionDenyTip: {
              condPanel: true
            }
          });
        }
      }, /*#__PURE__*/React.createElement("ul", {
        className: "menu-right custom-scroll"
      }, this.renderParameterList())) : /*#__PURE__*/React.createElement("ul", {
        className: "menu-right custom-scroll"
      }, this.renderParameterList()), this.state.showPermissionDenyTip["condPanel"] ? /*#__PURE__*/React.createElement("div", {
        id: "btn-NoRight",
        className: "conditionDiv"
      }, t('notAllow')) : null, /*#__PURE__*/React.createElement("div", {
        className: "conditionAdvancedBlock",
        onClick: function onClick() {
          _this4.setState({
            isShowAdvancedSettings: !_this4.state.isShowAdvancedSettings
          });
        }
      }, this.state.isShowAdvancedSettings ? t('analytic-setup.hideAdvSetting') : t('analytic-setup.showAdvSetting'))), /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(LoadingBtn, {
        className: "standard",
        title: t("buttonNames.cancel"),
        isLoading: this.state.isApplyLoading,
        onClick: this.handleCancel
      }), /*#__PURE__*/React.createElement(LoadingBtn, {
        className: "submit",
        title: t("buttonNames.save"),
        isLoading: this.state.isApplyLoading,
        onClick: this.handleSave,
        permissionDeny: this.props.permissionDeny,
        disabled: isDisableSubmit
      }))))));
    }
  }]);

  return ConditionSetupPopup;
}(Component);

var GRAPHIC_OPACITY = 0.6; // get the objects for drawing tool 

function getDrawingObjs(objCount) {
  var geometry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opacity = arguments.length > 2 ? arguments[2] : undefined;

  try {
    if (objCount == 0) {
      return [];
    }

    var geo = geometry;

    if (!opacity) {
      opacity = GRAPHIC_OPACITY;
    }

    var key = _.get(geo, '$.id');

    return [_objectSpread(_objectSpread({}, geo), {}, {
      id: key,
      opacity: opacity
    })];
  } catch (error) {
    console.error('getDrawingObjs fail', error);
    return [];
  }
}

ConditionSetupPopup.propTypes = {
  onClose: PropTypes.func,
  supportPercentage: PropTypes.bool
}; // const selectConditionSetupPopup = (state, ownProps) => {
//     let permissionDeny = (selectProductVersion(state) === "telstra") || fph.getAnalysisPermissionDeny(state)
//     return {
//         permissionDeny,
//         lng: selectLng(state)
//     }
// }
// export default connect(selectConditionSetupPopup)(ConditionSetupPopup)

export default ConditionSetupPopup;